module.exports = __webpack_public_path__ + "static/media/guidelines.55d47620.txt";